import { localized } from 'state/i18n';
import { ColumnGeneric, SortingGeneric, TableColumnWidthInfoGeneric } from '../history-table-settings/types';
import { ITableSettings, IUnitServiceHistoryDto } from 'api/api';

export enum ServiceHistoryColumnNames {
    createdOn = 'createdOn',
	dateOfService = 'dateOfService',
	serviceDocumentType = 'serviceDocumentType',
	comment = 'comment',
	download = 'download',
	delete = 'delete',
}

export type ServiceHistoryDtoExtraKeys = 'download' | 'delete';
export type ServiceHistoryDtoKeys = keyof IUnitServiceHistoryDto | ServiceHistoryDtoExtraKeys;

// These are the columns that will be rendered.
export const allColumns: ColumnGeneric<ServiceHistoryDtoKeys>[] = [
	{ name: ServiceHistoryColumnNames.createdOn, title: localized('CreatedOn') },
	{ name: ServiceHistoryColumnNames.serviceDocumentType, title: localized('DocumentType') },
	{ name: ServiceHistoryColumnNames.dateOfService, title: localized('DateOfService') },
	{ name: ServiceHistoryColumnNames.comment, title: localized('Comment') },
	{ name: 'download', title: localized('download') },
	{ name: 'delete', title: localized('Delete') },
];

export interface ServiceHistoryTableSettingsState {
	columnWidths: TableColumnWidthInfoGeneric<ServiceHistoryDtoKeys>[];
	columnOrder: ServiceHistoryDtoKeys[];
	sorting: SortingGeneric<ServiceHistoryDtoKeys>[];
	columns: ColumnGeneric<ServiceHistoryDtoKeys>[];
	tableSettings: ITableSettings;
	loaded: boolean;
}
